<div class="d-flex gap-8 udex-mb-12 align-items-center">
  <h6 class="navigation__medium--l" data-cy="title">{{title | cxTranslate}}</h6>
  <dcp-icon-button-tooltip
    [openOnClick]="true"
    [openOnHover]="false"
    size="Small">
    <div class="details-tooltip">
      {{explainText}}
    </div>
  </dcp-icon-button-tooltip>
</div>
<div class="content">
  <div *ngIf="type === DetailType.CONTACT" class="image me-3">
    <div class="avatar body--s text-uppercase" data-cy="avatar">
      {{address?.firstName.slice(0, 1)}}{{address?.lastName.slice(0, 1)}}
    </div>
  </div>
  <div class="description">
    <ng-container *ngIf="address">
      <div *ngIf="type === DetailType.ADDRESS" data-cy="address">
        <div data-cy="address-details" class="body--s">
          <div data-cy="company-name" class="body--s">{{address?.companyName}}</div>
          <div data-cy="street" class="body--s">{{address?.line1}}</div>
          <div data-cy="city" class="body--s">{{address?.town}}</div>
          <div data-cy="country" class="body--s">{{address?.country?.isocode}}</div>
        </div>
      </div>
      <div *ngIf="type === DetailType.CONTACT" data-cy="contact">
        <div class="body--s font-weight--medium full-name"
             data-cy="full-name">
          {{address?.firstName}} {{address?.lastName}}
        </div>
        <div class="body--s email" data-cy="email">{{address?.email}}</div>
      </div>
    </ng-container>
  </div>
</div>

